import postRobot from 'post-robot';

import { clearImpersonationData } from '../utils/helpers/storage';

export const getImpersonate = async () => {
  try {
    const { data } = await postRobot.send(window.opener, 'getImpersonate');

    // clear any previous impersonation data
    clearImpersonationData();

    return data;
  } catch (error) {
    return null;
  }
};
